import { useActiveThemeset, useGetThemesetColors } from '../../../../../queries/themesets';
import InspectorPanelColorPicker from '../../ColorPicker';
import { SettingsAccordion } from '../../SettingsAccordion';
import { deleteStyle, getValueFromStyles, updateStyles } from '../../helpers';
import { CSS_PROPERTIES } from '../../constants';
import { Thumbnail, token } from '@bynder/design-system';
import { IconColor } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';

const SpacerColorPicker: React.FC<{
  style: string;
  handleStyleChange: (style: string) => void;
}> = ({ style, handleStyleChange }) => {
  const { translate } = useTranslate();
  const { data: themeset } = useActiveThemeset();
  const customColors = [...useGetThemesetColors()];

  const findActiveColor = (property, selector?) => {
    return customColors.find(
      color => color.hexCode === getValueFromStyles(style, property, selector),
    );
  };

  const handleClear = (property, selector?) => {
    const newStyle = deleteStyle(style, property, selector);
    handleStyleChange(newStyle);
  };

  const handleClick = (colorId, property, selector?) => {
    const selectedColor = customColors.find(color => color.id === colorId);
    let newStyle;
    if (selector) {
      newStyle = updateStyles(
        style,
        `${selector} {${property}: ${selectedColor?.hexCode}}`,
      );
    } else {
      newStyle = updateStyles(style, `${property}: ${selectedColor?.hexCode}`);
    }
    handleStyleChange(newStyle);
  };

  const defaultSpacerColor =
    themeset?.widgets.spacingDivider?.color?.hexCode ||
    token.gray300a;

  return (
    <SettingsAccordion
      title={translate('WIDGET_INSPECTOR.CARD_COLORS_ACCORDION')}
      thumbnail={<Thumbnail icon={<IconColor />} />}
    >
      <InspectorPanelColorPicker
        testId="spacerWidgetDividerColorPicker"
        defaultColorHex={defaultSpacerColor}
        colors={customColors}
        activeColor={findActiveColor(CSS_PROPERTIES.BORDER_COLOR)}
        label={translate('WIDGET_INSPECTOR.SPACER_WIDGET_DIVIDER_COLOR')}
        handleClear={() => handleClear(CSS_PROPERTIES.BORDER_COLOR)}
        handleClick={colorId =>
          handleClick(colorId, CSS_PROPERTIES.BORDER_COLOR)
        }
      />
    </SettingsAccordion>
  );
};

export default SpacerColorPicker;
